const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20cinematic%20scene%20with%20dramatic%20golden%20nebula%20and%20cosmic%20landscape%2C%20warm%20amber%20and%20deep%20space%20contrast%2C%20grand%20scale%20composition%2C%20movie%20poster%20aesthetic%2C%20no%20text%20no%20people%2C%20sophisticated%20cinematic%20style&width=1200&height=600&seq=carousel-scifi-01&orientation=landscape',
    title: '科幻纪元：年度最值得期待的太空史诗',
    desc: '从星际穿越到宇宙探索，盘点2026年不容错过的科幻巨制，每一部都是视觉与想象力的双重盛宴。',
    tag: '焦点专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20silhouette%20at%20golden%20sunset%20with%20dramatic%20clouds%2C%20warm%20amber%20and%20coral%20sky%2C%20cinematic%20historical%20drama%20atmosphere%2C%20elegant%20minimalist%20composition%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-drama-02&orientation=landscape',
    title: '国剧之光：近五年现象级电视剧回顾',
    desc: '从繁花到长安十二时辰，这些国产电视剧用精良制作和深刻叙事，重新定义了华语剧集的高度。',
    tag: '深度回顾',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20anime%20inspired%20landscape%20with%20flowing%20energy%20waves%20and%20golden%20sunset%20sky%2C%20vibrant%20warm%20coral%20and%20amber%20color%20palette%2C%20epic%20cinematic%20composition%2C%20no%20text%20no%20characters&width=1200&height=600&seq=carousel-anime-03&orientation=landscape',
    title: '国漫新势力：原创动画的黄金时代',
    desc: '从大圣归来到深海，国产动画电影正在经历前所未有的创作繁荣，一部部佳作正在刷新票房与口碑纪录。',
    tag: '趋势观察',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20atmospheric%20abstract%20scene%20with%20deep%20shadows%20and%20warm%20amber%20light%20piercing%20through%20darkness%2C%20suspenseful%20cinematic%20mood%2C%20elegant%20horror%20aesthetic%2C%20minimalist%20composition%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-horror-04&orientation=landscape',
    title: '夏日纳凉：精选高分悬疑惊悚片单',
    desc: '炎炎夏日不如来一部透心凉的悬疑惊悚片，从烧脑剧情到心理恐怖，带你体验不一样的观影刺激。',
    tag: '主题策划',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20documentary%20style%20abstract%20landscape%20with%20soft%20natural%20light%20and%20earthy%20tones%2C%20golden%20hour%20atmosphere%2C%20cinematic%20realism%20aesthetic%2C%20elegant%20minimalist%20composition%2C%20no%20text%20no%20people&width=1200&height=600&seq=carousel-doc-05&orientation=landscape',
    title: '真实的力量：不可错过的优秀纪录片',
    desc: '从自然奇观到人文故事，这些高分纪录片用镜头捕捉真实世界的震撼与感动，拓展认知的边界。',
    tag: '知识影像',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          编辑团队深度策划，带你发现更多好内容
        </p>

        <div className="flex flex-col gap-5 max-w-6xl mx-auto">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <div className="flex flex-col md:flex-row">
                <div className={`relative overflow-hidden flex-shrink-0 ${i === 0 ? 'md:w-[480px]' : 'md:w-[360px]'} w-full aspect-[16/7] md:aspect-auto`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}